import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconPrinter', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M13.6 11.2H12V9.6C12 9.1576 11.6424 8.8 11.2 8.8H4.79999C4.35759 8.8 3.99999 9.1576 3.99999 9.6V11.2H2.39999V6.4H4.79999H11.2H13.6V11.2ZM5.59999 13.6H10.4V10.4H5.59999V13.6ZM5.59999 4.8H10.4V2.4H5.59999V4.8ZM14.4 4.8H12V1.6C12 1.1576 11.6424 0.799999 11.2 0.799999H4.79999C4.35759 0.799999 3.99999 1.1576 3.99999 1.6V4.8H1.59999C1.15759 4.8 0.799988 5.1576 0.799988 5.6V12C0.799988 12.4424 1.15759 12.8 1.59999 12.8H3.99999V14.4C3.99999 14.8424 4.35759 15.2 4.79999 15.2H11.2C11.6424 15.2 12 14.8424 12 14.4V12.8H14.4C14.8424 12.8 15.2 12.4424 15.2 12V5.6C15.2 5.1576 14.8424 4.8 14.4 4.8V4.8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M17 14H15V12C15 11.447 14.553 11 14 11H6C5.447 11 5 11.447 5 12V14H3V8H6H14H17V14ZM7 17H13V13H7V17ZM7 6H13V3H7V6ZM18 6H15V2C15 1.447 14.553 1 14 1H6C5.447 1 5 1.447 5 2V6H2C1.447 6 1 6.447 1 7V15C1 15.553 1.447 16 2 16H5V18C5 18.553 5.447 19 6 19H14C14.553 19 15 18.553 15 18V16H18C18.553 16 19 15.553 19 15V7C19 6.447 18.553 6 18 6V6Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M20.4 16.8H18V14.4C18 13.7364 17.4636 13.2 16.8 13.2H7.20001C6.53641 13.2 6.00001 13.7364 6.00001 14.4V16.8H3.60001V9.6H7.20001H16.8H20.4V16.8ZM8.40001 20.4H15.6V15.6H8.40001V20.4ZM8.40001 7.2H15.6V3.6H8.40001V7.2ZM21.6 7.2H18V2.4C18 1.7364 17.4636 1.2 16.8 1.2H7.20001C6.53641 1.2 6.00001 1.7364 6.00001 2.4V7.2H2.40001C1.73641 7.2 1.20001 7.7364 1.20001 8.4V18C1.20001 18.6636 1.73641 19.2 2.40001 19.2H6.00001V21.6C6.00001 22.2636 6.53641 22.8 7.20001 22.8H16.8C17.4636 22.8 18 22.2636 18 21.6V19.2H21.6C22.2636 19.2 22.8 18.6636 22.8 18V8.4C22.8 7.7364 22.2636 7.2 21.6 7.2V7.2Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M27.2 22.4H24V19.2C24 18.3152 23.2848 17.6 22.4 17.6H9.59998C8.71518 17.6 7.99998 18.3152 7.99998 19.2V22.4H4.79998V12.8H9.59998H22.4H27.2V22.4ZM11.2 27.2H20.8V20.8H11.2V27.2ZM11.2 9.6H20.8V4.8H11.2V9.6ZM28.8 9.6H24V3.2C24 2.3152 23.2848 1.6 22.4 1.6H9.59998C8.71518 1.6 7.99998 2.3152 7.99998 3.2V9.6H3.19998C2.31518 9.6 1.59998 10.3152 1.59998 11.2V24C1.59998 24.8848 2.31518 25.6 3.19998 25.6H7.99998V28.8C7.99998 29.6848 8.71518 30.4 9.59998 30.4H22.4C23.2848 30.4 24 29.6848 24 28.8V25.6H28.8C29.6848 25.6 30.4 24.8848 30.4 24V11.2C30.4 10.3152 29.6848 9.6 28.8 9.6V9.6Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));